<div class="!h-[4rem] sm:!h-[437px] main-header-wrapper">
  <div class="hidden sm:block header-cover !py-7 header">
    <div [ngSwitch]="accommodation()">
      <img *ngSwitchCase="'ecolodge'" [src]="'../../../../assets/images/home-ecolodge-banner.jfif'" draggable="false"
        alt="تصویر اصلی ایران هتل - IranHotelOnline's main header image" class="object-cover h-[300px] rounded-[40px]"
        loading='eager' priority height="372" width="1820" [@fadeAnimation]="'ecolodge'">
      <img *ngSwitchCase="'/'" [src]="'../../../../assets/images/Header-Site.jpg'" draggable="false"
        alt="تصویر اصلی ایران هتل - IranHotelOnline's main header image" class="object-cover h-[300px] rounded-[40px]"
        loading='eager' priority height="372" width="1820" [@fadeAnimation]="'hotel'">
        <img *ngSwitchCase="''" [src]="'../../../../assets/images/Header-Site.jpg'" draggable="false"
          alt="تصویر اصلی ایران هتل - IranHotelOnline's main header image" class="object-cover h-[300px] rounded-[40px]"
          loading='eager' priority height="372" width="1820" [@fadeAnimation]="'hotel'">
      <img *ngSwitchCase="'villa-mashhad'" [src]="'../../../../assets/images/special-banner.jpg'" draggable="false"
        alt="تصویر اصلی ایران هتل - IranHotelOnline's main header image" class="object-cover h-[300px] rounded-[40px]"
        loading='eager' priority height="372" width="1820" [@fadeAnimation]="'special'">
    </div>

  </div>
  <section class="searchbox-desktop container px-4 lg:px-0 hidden md:block absolute bottom-0 right-0 left-0">
    <iho-desktop-searchbox />
  </section>
  <section class="searchbox-mobile block md:hidden absolute top-6 right-0 left-0">
    <iho-mobile-searchbox class="flex flex-col" />
  </section>
</div>
<ng-template #headerSkeleton>
  <ng-container *ngIf="csrStatus">
    <iho-header-skeleton />
  </ng-container>
</ng-template>